import axios from "axios";
import PhoneNumber from 'awesome-phonenumber';
import moment from "moment";

const apiServer = `${process.env.REACT_APP_SERVER_PROTOCOL}://${process.env.REACT_APP_ADDRESS}:${process.env.REACT_APP_PORT}`;

// <editor-fold desc="Functions">
export function formatPhoneNumber(number) {
    try {
        const phoneNumber = new PhoneNumber(number, 'us');
        if (phoneNumber.isPossible()) {
            return phoneNumber.getNumber('national');
        } else {
            return number;
        }
    } catch (e) {
        return number;
    }
}

export function formatDate(date) {
    let dateStr = moment(date).format("MM-DD-YYYY");

    return dateStr === "Invalid date" ? "" : dateStr;
}

export function formatDateMMYY(date) {
    if (date === undefined) return "";

    let dateStr = moment(date).format("MM-YY");

    return dateStr === "Invalid date" ? "" : dateStr;
}

function callAPI(endpoint, callback) {
    axios.get(`${apiServer}${endpoint}`)
        .then(res => callback(res.data))
        .catch(_ => callback(false));
}

const methods = {
    get: 'get',
    put: 'put',
    post: 'post',
    delete: 'delete'
}

function callProtectedAPI(method, endpoint, callback, data = null) {
    const config = {headers: {Authorization: `Bearer ${localStorage.getItem('accessToken')}`}};

    switch (method) {
        case methods.get:
            axios.get(`${apiServer}${endpoint}`, config)
                .then(res => {callback(res.data)})
                .catch(_ => callback(false));
            break;
        case methods.put:
            axios.put(`${apiServer}${endpoint}`, data, config)
                .then(res => {callback(res.data)})
                .catch(_ => callback(false));
            break;
        case methods.post:
            axios.post(`${apiServer}${endpoint}`, data, config)
                .then(res => {callback(res.data)})
                .catch(_ => callback(false));
            break;
        case methods.delete:
            axios.delete(`${apiServer}${endpoint}`, config)
                .then(res => {callback(res)})
                .catch(_ => callback(false));
            break;
        default:
            console.log(`${method} is not a valid method`);
    }
}
// </editor-fold desc="Functions">

export function pingAPI(callback) {
    callAPI(`/api/ping`,res => {callback(res)});
}

// <editor-fold desc="Jobs">
export function getNextJobNumber(callback) {
    callAPI(`/api/job/nextNumber`,res => {callback(res)});
}

export function createNewJob(_jobObject, callback) {
    callProtectedAPI(methods.post, `/api/job/new`,
            res => {callback(res)}
        , _jobObject);
}

export function editJob(_jobObject, _jobId, callback) {
    callProtectedAPI(methods.post, `/api/job/edit/${_jobId}`,
            res => {callback(res)}
        , {jobId: _jobId,job: _jobObject})
}

export function setJobStatus(_status, _jobId, callback) {
    callProtectedAPI(methods.post, `/api/job/status/${_jobId}/${_status}`,
                    res => {callback(res)});
}

export function pushInvoices(_invoices, callback) {
    callProtectedAPI(methods.post, `/api/jobs/status/invoices`,
        res => {callback(res)}, _invoices);
}

export function getJobCount(callback) {
    callAPI(`/api/jobs/count`,res => {callback(res)});
}

export function getJob(_jobId, callback) {
    callProtectedAPI(methods.get,`/api/job/${_jobId}`,
            res => callback(res));
}

export function getJobs(callback, limit = 50, offset = 0, estimates = false, nonInvoicedOnly = false) {
    if (nonInvoicedOnly) {
        callProtectedAPI(methods.get, '/api/jobs/notInvoiced',
            res => callback(res));
    } else {
        callProtectedAPI(methods.get, `/api/jobs/${limit}/${offset}/${estimates}`,
            res => callback(res));
    }
}

export function deleteJob(_jobId, data, callback) {
    let jobNumber = data.jobNumber;

    if (data.jobNumberAppend !== null && data.jobNumberAppend !== undefined) {
        jobNumber += data.jobNumberAppend;
    }

    callProtectedAPI(methods.delete, `/api/job/delete/${_jobId}/${jobNumber}`,
        res => callback(res));
}

export function getAdvancedSearch(data, callback) {
    callProtectedAPI(methods.post, '/api/jobs/search',
            res => callback(res), data);
}

export function getJobIdByNumber(_jobNumber, callback) {
    if (_jobNumber === '' || !_jobNumber.match(/^\d/)) {
        return callback(false);
    }

    callProtectedAPI(methods.get, `/api/jobIdByNumber/${_jobNumber}`,
        res => callback(res));
}
// </editor-fold desc="Jobs">

// <editor-fold desc="Clients">
export function getClients(callback) {
    callProtectedAPI(methods.get, `/api/clients`,
            res => callback(res));
}

export function getClient(_clientId, callback) {
    callProtectedAPI(methods.get, `/api/client/${_clientId}`,
        res => callback(res));
}

export function getClientAddresses(_clientId, callback) {
    callProtectedAPI(methods.get, `/api/client/${_clientId}/addresses`,
        res => callback(res));
}

export function getClientContacts(_clientId, callback) {
    callProtectedAPI(methods.get, `/api/client/${_clientId}/contacts`,
        res => callback(res));
}

export function getClientJobs(_clientId, callback) {
    callProtectedAPI(methods.get, `/api/client/${_clientId}/jobs`,
        res => callback(res));
}

export function createNewClient(_clientObject, callback) {
    callProtectedAPI(methods.post, `/api/client/new`,
        res => callback(res), _clientObject);
}

export function editClient(_clientObject, callback) {
    callProtectedAPI(methods.post, `/api/client/edit`,
        res => callback(res), _clientObject);
}

export function createAddress(_addressObject, callback) {
    callProtectedAPI(methods.post, `/api/address/new`,
        res => callback(res), _addressObject);
}

export function editAddress(_addressObject, callback) {
    callProtectedAPI(methods.put, `/api/address/edit`,
        res => callback(res), _addressObject);
}

export function deleteAddress(_addressToDelete, callback) {
    callProtectedAPI(methods.delete, `/api/address/delete/${_addressToDelete.id}`,
        res => callback(res));
}

export function createContact(_contactObject, callback) {
    callProtectedAPI(methods.post, `/api/contact/new`,
        res => callback(res), _contactObject);
}

export function editContact(_contactObject, callback) {
    callProtectedAPI(methods.put, `/api/contact/edit`,
        res => callback(res), _contactObject);
}

export function deleteContact(_contactToDelete, callback) {
    callProtectedAPI(methods.delete, `/api/contact/delete/${_contactToDelete.id}`,
        res => callback(res));
}
// </editor-fold desc="Clients">

// <editor-fold desc="Users">
export function getUserData(_userId, callback) {
    callProtectedAPI(methods.get, `/api/user/${_userId}`,
            res => {callback(res)});
}

export function editUser(_userObject, callback) {
    callProtectedAPI(methods.put, `/api/user/edit`,
            res => callback(res), _userObject);
}
// </editor-fold desc="Users">


export const statusTypes = [
    'New',
    'Ordered',
    'Printed',
    'Delivered',
    'Invoiced',
    'Canceled'
]


export function formatUSD(_value) {
    if (_value === undefined) return "";

    if (_value === 0 || _value === "0") return "";

    _value = _value.toString();
    const USDollar = new Intl.NumberFormat('en-US', {
        style: "currency",
        currency: "USD"
    });

    let valNum = _value.match(/[0-9.]+/);

    return valNum === null || valNum === undefined ? _value : USDollar.format(Number(valNum[0]));
}